import React, { useState, useEffect } from 'react';
import { EaseTable } from '../../../libs/EaseTable';
import { isMobile } from 'react-device-detect';
import { MerchantBankAccount } from '../../../models';
import { handleApiExceptions, generate_query_set, alertify } from '../../../app_methods';
import { connect } from 'react-redux';
import { Button, Icon } from "antd";
import { updateCurrentUserAction } from "../../../redux/actions";
import { AddBankAccountModal } from '../../Common';
import { PermissionHoc } from "../../HOC";
import { getBankAccountsTableColumns } from './constants';

const MerchantBankAccountList = (props) => {
    const [accounts, setAccounts] = useState([]);
    const [currentAccount, setCurrentAccount] = useState({});
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [showBankAccountModal, setShowBankAccountModal] = useState(false);

    const PermissableButton = PermissionHoc(Button, null, { is_component: true, fallbackComponent: null })

    const [pagination, setPagination] = useState({
        pageSize: 10,
        total: 0,
        current: 1,
        showSizeChanger: true,
        pageSizeOptions: ["10", "25", "50", "100"],
        showTotal: (total) => `Total ${total} Records`
    });

    const prepFilters = (filters) => {
        let _filters = { ...filters };
        if (_filters.created_at && _filters.created_at.length) {
            _filters.created_at_start = _filters.created_at[0].format("YYYY-MM-DD");
            _filters.created_at_end = _filters.created_at[1].format("YYYY-MM-DD");
            delete _filters.created_at;
        }
        return _filters;
    };

    const [filters, setFilters] = useState({});



    const handleTableChange = (tableInfo) => {
        if (tableInfo.trigger == "columns") return;
        let _pagination = tableInfo.pagination;
        if (tableInfo.trigger == "filters") _pagination.current = 1;
        setPagination(_pagination);
        setFilters(tableInfo.filters);
        fetchBankAccounts(_pagination, tableInfo.filters);
    };

    const fetchBankAccounts = async (_pagination = pagination, _filters = filters) => {
        if (!props.current_user.key) return;
        setIsTableLoading(true);
        const response = await MerchantBankAccount.list({ ...{ pageSize: _pagination.pageSize, current: _pagination.current }, ...prepFilters(_filters) })
        if (!response.success) {
            setIsTableLoading(false);
            handleApiExceptions(response);
            return;
        }
        let queryset = generate_query_set(MerchantBankAccount, response.data.results)
        setAccounts(queryset);
        setPagination({ ...pagination, total: response.data.count });
        setIsTableLoading(false);
    };

    const toggleBankAccountModal = (currentAccount) => {
        setCurrentAccount(currentAccount)
        setShowBankAccountModal(!showBankAccountModal);
    };

    const saveBankAccount = async (values) => {
        if (typeof values.cancelled_cheque == 'string'){
            delete values['cancelled_cheque']
        }
        if(typeof values.other_document == 'string'){
            delete values['other_document']
        }
        setIsSaving(true);
        const account = new MerchantBankAccount();
        const response = await account.save({ ...values, key: props.current_user.key });
        if (!response.success) {
            setIsSaving(false);
            handleApiExceptions(response);
            return;
        }
        toggleBankAccountModal({ ...values, is_edit: true });
        fetchBankAccounts(pagination, filters);
        setIsSaving(false);
        alertify("Success",response.data.message,"success",);
    };

    const tableColumns = getBankAccountsTableColumns({toggleBankAccountModal})

    useEffect(() => {
        let defaultFilters = {};
        setFilters({ ...filters, ...defaultFilters });
        fetchBankAccounts(pagination, { ...filters,  ...defaultFilters });
    }, []);
    return (
        <>
            <div className="w-100 d-flex justify-content-end">
                <PermissableButton required_permission="WIRE_FUNDING_ACCOUNT_WRITE" type="primary" onClick={toggleBankAccountModal}><Icon type="plus" />  Add Funding Account</PermissableButton>
            </div>
            <EaseTable
                rowKey="id"
                loading={isTableLoading}
                data={accounts}
                columns={tableColumns}
                fixedSelectable={!isMobile}
                pagination={pagination}
                handleTableChange={handleTableChange}
                totalRecords={pagination.total}
            />
            <AddBankAccountModal
                visible={showBankAccountModal}
                account={currentAccount}
                toggleBankAccountModal={toggleBankAccountModal}
                saveBankAccount={saveBankAccount}
                loading={isSaving}
            />
        </>
    )
}

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});


const mapDispatchToProps = (dispatch) => ({
	updateCurrentUser: (user) => dispatch(updateCurrentUserAction(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PermissionHoc(MerchantBankAccountList,"WIRE_FUNDING_ACCOUNT_READ"));
